<template>
    <div>
        <b-modal :id="modalId" :title="title" size="xl" scrollable centered ok-only ok-title="Cerrar"
            ok-variant="primary" class="product-list-modal" body-class="p-0">
            <!-- Header con búsqueda -->
            <div class="modal-custom-header py-3 bg-light border-bottom">
                <div class="d-flex flex-column flex-md-row">
                    <b-input-group class="search-input-group col-12 col-md-6 py-2">
                        <b-form-input v-model="searchQuery"
                            :placeholder="keyProduct === 'tank' ? 'Buscar por producto o número de tanque...' : 'Buscar productos...'"
                            size="sm">
                        </b-form-input>
                    </b-input-group>

                    <!-- Filtros -->
                    <div class="col-12 col-md-6 px-0">
                        <div class="d-flex flex-column flex-md-row gap-2">
                            <!-- Filtro de Estado (ahora con Element UI) -->
                        <el-select
                            v-model="selectedState"
                            placeholder="Estado"
                            clearable
                            filterable
                            class="product-select col-12 col-md-4 py-2"
                            size="mini"
                        >
                            <el-option
                                v-for="option in stateOptions"
                                :key="option.value"
                                :label="option.text"
                                :value="option.value"
                            />
                            </el-select>

                            <!-- Filtro de Estado de Inventario -->
                            <el-select
                                v-if="keyProduct === 'status_inventory' || keyProduct === 'caracterized' || keyProduct === 'not_caracterized_with_cumply' || keyProduct === 'not_caracterized_not_cumply' || keyProduct === 'not_document'"
                            v-model="selectedInventoryStatus"
                            placeholder="Estado de Inventario"
                            clearable
                            filterable
                            class="product-select col-12 col-md-4 py-2"
                             size="mini" 
                        >
                            <el-option
                                v-for="option in inventoryStatusOptions"
                                :key="option.value"
                                :label="option.text"
                                :value="option.value"
                            />
                            </el-select>

                            <!-- Filtro de Disponibilidad en Inventario -->
                            <el-select
                                v-if="keyProduct === 'inventory_availability' || keyProduct === 'not_use' || keyProduct === 'used'"
                            v-model="selectedAvailability"
                            placeholder="Disponibilidad"
                            clearable
                            filterable
                            class="product-select col-12 col-md-4 py-2"
                             size="mini" 
                        >
                            <el-option
                                v-for="option in availabilityOptions"
                                :key="option.value"
                                :label="option.text"
                                :value="option.value"
                            />
                            </el-select>

                            <!-- Filtro de Unidad (solo para tanks) -->
                        <el-select
                            v-if="keyProduct === 'tank'"
                            v-model="selectedVolumeUnit"
                            placeholder="Unidad"
                            clearable
                            filterable
                            class="product-select col-12 col-md-4 py-2"
                             size="mini" 
                        >
                            <el-option
                                v-for="option in volumeUnitOptions"
                                :key="option.value"
                                :label="option.text"
                                :value="option.value"
                            />
                            </el-select>

                            <!-- Filtro de Grupos (solo para carcinogenicidad) -->
                        <el-select
                            v-if="keyProduct === 'carcinogenicity'"
                            v-model="selectedGroup"
                            placeholder="Grupo"
                            clearable
                            filterable
                            class="product-select col-12 col-md-4 py-2"
                             size="mini" 
                        >
                            <el-option
                                v-for="option in groupOptions"
                                :key="option.value"
                                :label="option.text"
                                :value="option.value"
                            />
                            </el-select>

                            <!-- Filtro de Nivel Neurotóxico (solo para neurotoxic) -->
                        <el-select
                            v-if="keyProduct === 'neurotoxic'"
                            v-model="selectedNeurotoxicLevel"
                            placeholder="Nivel"
                            clearable
                            filterable
                            class="product-select col-12 col-md-4 py-2"
                             size="mini" 
                        >
                            <el-option
                                v-for="option in neurotoxicLevelOptions"
                                :key="option.value"
                                :label="option.text"
                                :value="option.value"
                            />
                            </el-select>

                            <!-- Filtro de Tipo de Sensibilización (solo para sensitizing) -->
                        <el-select
                            v-if="keyProduct === 'sensitizing'"
                            v-model="selectedSensitizingType"
                            placeholder="Tipo"
                            clearable
                            filterable
                            class="product-select col-12 col-md-4 py-2"
                             size="mini" 
                        >
                            <el-option
                                v-for="option in sensitizingTypeOptions"
                                :key="option.value"
                                :label="option.text"
                                :value="option.value"
                            />
                            </el-select>

                            <!-- Filtro de Tipo de Toxicidad Aguda -->
                        <el-select
                            v-if="keyProduct === 'toxicity_agude_toxicity'"
                            v-model="selectedToxicityType"
                            placeholder="Tipo"
                            clearable
                            filterable
                            class="product-select col-12 col-md-4 py-2"
                             size="mini" 
                        >
                            <el-option
                                v-for="option in toxicityTypeOptions"
                                :key="option.value"
                                :label="option.text"
                                :value="option.value"
                            />
                            </el-select>

                            <!-- Filtro de Tipo de Exposición a Órganos Diana -->
                        <el-select
                            v-if="keyProduct === 'target_organs'"
                            v-model="selectedTargetOrgansType"
                            placeholder="Tipo"
                            clearable
                            filterable
                            class="product-select col-12 col-md-4 py-2"
                             size="mini" 
                        >
                            <el-option
                                v-for="option in targetOrgansTypeOptions"
                                :key="option.value"
                                :label="option.text"
                                :value="option.value"
                            />
                            </el-select>

                            <!-- Filtro de Tipo de SGA -->
                        <el-select
                            v-if="keyProduct === 'risk-inventory'"
                            v-model="selectedSgaType"
                            placeholder="Tipo"
                            clearable
                            filterable
                            class="product-select col-12 col-md-4 py-2"
                            size="mini" 
                        >
                            <el-option
                                v-for="option in sgaTypeOptions"
                                :key="option.value"
                                :label="option.text"
                                :value="option.value"
                            />
                            </el-select>

                            <!-- Filtro de Código de SGA -->
                            <el-select
                                v-if="(keyProduct === 'risk-inventory' && selectedSgaType) || keyProduct === 'sga_health' || keyProduct === 'sga_environment' || keyProduct === 'sga_physical'"
                            v-model="selectedSgaCode"
                            placeholder="Código"
                            clearable
                            filterable
                            class="product-select col-12 col-md-4 py-2"
                            size="mini" 
                        >
                            <el-option
                                v-for="option in sgaCodeOptions"
                                :key="option.value"
                                :label="option.text"
                                :value="option.value"
                            />
                            </el-select>


                            <!-- Filtro de Estado de Revisión -->
                        <el-select
                            v-if="keyProduct === 'cumply_review' && showReviewSection"
                            v-model="selectedComplianceStatus"
                            placeholder="Estado de Revisión"
                            clearable
                            filterable
                            class="product-select col-12 col-md-4 py-2"
                             size="mini" 
                        >
                            <el-option
                                v-for="option in complianceStatusOptions"
                                :key="option.value"
                                :label="option.text"
                                :value="option.value"
                            />
                            </el-select>

                            <!-- Filtro de Tipo de Exposición para Toxicidad Aguda -->
                        <el-select
                            v-if="keyProduct === 'acute_toxicity_mortal'"
                            v-model="selectedExposureType"
                            placeholder="Tipo de Exposición"
                            clearable
                            filterable
                            class="product-select col-12 col-md-4 py-2"
                             size="mini" 
                        >
                            <el-option
                                v-for="option in exposureTypeOptions"
                                :key="option.value"
                                :label="option.text"
                                :value="option.value"
                            />
                            </el-select>

                            <!-- Filtro de Categoría para Toxicidad Aguda -->
                        <el-select
                            v-if="keyProduct === 'acute_toxicity_mortal'"
                            v-model="selectedToxicityCategory"
                            placeholder="Categoría"
                            clearable
                            filterable
                            class="product-select col-12 col-md-4 py-2"
                             size="mini" 
                        >
                            <el-option
                                v-for="option in toxicityCategoryOptions"
                                :key="option.value"
                                :label="option.text"
                                :value="option.value"
                            />
                            </el-select>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Tabla Principal -->
            <div class="px-4 py-3">
            <b-table :items="filteredProducts" :fields="dynamicFields" :current-page="currentPage" :per-page="pageSize"
                empty-text="" show-empty stacked="md" hover responsive class="modern-table">
                    <!-- Columna del Producto -->
                    <template #cell(name)="row">
                        <div class="product-info">
                            <div class="product-details">
                                <div class="product-name">{{ row.item.name }}</div>
                                <div class="product-manufacturer">{{ row.item.manufacturer }}</div>
                            </div>
                        </div>
                    </template>

                    <!-- Estado -->
                    <template #cell(state)="row">
                        <div class="state-badge" :class="getStateClass(row.item.state)">
                            <i :class="getStateIcon(row.item.state)"></i>
                            <span class="state-text">{{ row.item.state }}</span>
                        </div>
                    </template>

                    <!-- Tank Number -->
                    <template v-if="keyProduct === 'tank'" #cell(tank_number)="row">
                        <div class="text-center">{{ row.item.tank_number }}</div>
                    </template>

                    <!-- Quantity -->
                    <template v-if="keyProduct === 'tank'" #cell(quantity)="row">
                        <div class="text-center">{{ row.item.quantity }}</div>
                    </template>

                    <!-- Volume Unit -->
                    <template v-if="keyProduct === 'tank'" #cell(volume_unit)="row">
                        <div class="text-center">{{ row.item.volume_unit }}</div>
                    </template>

                    <!-- Categorías para toxicidad aguda -->
                    <template v-if="keyProduct === 'acute_toxicity_mortal'" #cell(categories)="row">
                        <div class="categories-wrapper">
                            <template v-for="(category, type) in row.item.categories">
                                <div v-for="(value, cat) in category" :key="`${type}-${cat}`" v-if="value"
                                    class="category-badge" :class="getCategoryClass(cat)">
                                    <i class="fa" :class="getCategoryIcon(type)"></i>
                                    <span class="category-text">
                                    {{ type === 'oral' ? 'Ingestión' : type === 'dermal' ? 'Dérmica' : 'Inhalación' }}
                                        {{ cat.split('_')[1] }}
                                    </span>
                                </div>
                            </template>
                        </div>
                    </template>

                    <!-- Grupos de carcinogenicidad -->
                    <template v-else-if="keyProduct === 'carcinogenicity'" #cell(categories)="row">
                        <div class="categories-wrapper">
                            <template v-for="(value, group) in row.item.groups">
                                <div v-if="value" :key="group" class="category-badge"
                                    :class="getCarcinogenicityClass(group)">
                                    <i class="fa fa-exclamation-triangle"></i>
                                    <span class="category-text">
                                        {{ getCarcinogenicityLabel(group) }}
                                    </span>
                                </div>
                            </template>
                        </div>
                    </template>

                    <!-- Niveles neurotóxicos -->
                    <template v-else-if="keyProduct === 'neurotoxic'" #cell(categories)="row">
                        <div class="categories-wrapper">
                            <div class="category-badge" :class="getNeurotoxicClass(row.item.neurotoxic_level)">
                                <i class="fa fa-brain"></i>
                                <span class="category-text">
                                    {{ getNeurotoxicLabel(row.item.neurotoxic_level) }}
                                </span>
                            </div>
                        </div>
                    </template>

                    <!-- Corrosividad -->
                    <template v-else-if="keyProduct === 'corrosive'" #cell(categories)="row">
                        <div class="categories-wrapper">
                            <div v-if="row.item.corrosive.ocular" class="category-badge corrosive-ocular">
                                <i class="fa fa-eye"></i>
                                <span class="category-text">Ojos</span>
                            </div>
                            <div v-if="row.item.corrosive.dermal" class="category-badge corrosive-dermal">
                                <i class="fa fa-hand-paper-o"></i>
                                <span class="category-text">Piel</span>
                            </div>
                        </div>
                    </template>

                    <!-- Sensibilización -->
                    <template v-else-if="keyProduct === 'sensitizing'" #cell(categories)="row">
                        <div class="categories-wrapper">
                            <div v-if="row.item.sensitizing.dermal" class="category-badge sensitizing-dermal">
                                <i class="fa fa-hand-paper"></i>
                                <span class="category-text">Cutánea</span>
                            </div>
                            <div v-if="row.item.sensitizing.respiratory" class="category-badge sensitizing-respiratory">
                                <i class="fa fa-lungs"></i>
                                <span class="category-text">Respiratorios</span>
                            </div>
                        </div>
                    </template>

                    <!-- Toxicidad Aguda -->
                    <template v-else-if="keyProduct === 'toxicity_agude_toxicity'" #cell(categories)="row">
                        <div class="categories-wrapper">
                            <div v-if="row.item.toxicities.product_toxicity_agude_ingestion"
                                class="category-badge toxicity-ingestion">
                                <i class="fa fa-medkit"></i>
                                <span class="category-text">Ingestión</span>
                            </div>
                            <div v-if="row.item.toxicities.product_toxicity_inhalation"
                                class="category-badge toxicity-inhalation">
                                <i class="fa fa-cloud"></i>
                                <span class="category-text">Inhalación</span>
                            </div>
                        <div v-if="row.item.toxicities.product_toxicity_dermal" class="category-badge toxicity-dermal">
                                <i class="fa fa-hand-paper-o"></i>
                                <span class="category-text">Dérmica</span>
                            </div>
                        </div>
                    </template>

                    <!-- Órganos Diana -->
                    <template v-else-if="keyProduct === 'target_organs'" #cell(categories)="row">
                        <div class="categories-wrapper">
                            <div v-if="row.item.target_organs.product_target_organs_exposition_repetitive"
                                class="category-badge target-organs-repetitive">
                                <i class="fa fa-refresh"></i>
                                <span class="category-text">Exposición repetida</span>
                            </div>
                            <div v-if="row.item.target_organs.product_target_organs_exposition_unique"
                                class="category-badge target-organs-unique">
                                <i class="fa fa-exclamation-circle"></i>
                                <span class="category-text">Exposición única</span>
                            </div>
                        </div>
                    </template>

                    <!-- SGA Information -->
                    <template
                        v-else-if="keyProduct === 'sga_health' || keyProduct === 'sga_environment' || keyProduct === 'sga_physical' || keyProduct === 'risk-inventory'"
                        #cell(categories)="row">
                        <div class="sga-list-wrapper">
                            <!-- Health SGA -->
                            <div v-if="(keyProduct === 'sga_health' || keyProduct === 'risk-inventory') && row.item.sga && row.item.sga.health && row.item.sga.health.length"
                                class="sga-category-group">
                                <div v-if="keyProduct === 'risk-inventory'" class="sga-category-label">Salud</div>
                                <div class="sga-badges-container">
                                    <div v-for="(item, index) in row.item.sga.health" :key="'health-' + index"
                                        class="sga-badge sga-health">
                                        <span class="sga-code">{{ item.codigo }}</span>
                                        <span class="sga-divider">|</span>
                                        <span class="sga-description">{{ item.categoria }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Environment SGA -->
                            <div v-if="(keyProduct === 'sga_environment' || keyProduct === 'risk-inventory') && row.item.sga && row.item.sga.environment && row.item.sga.environment.length"
                                class="sga-category-group">
                                <div v-if="keyProduct === 'risk-inventory'" class="sga-category-label">Ambiente</div>
                                <div class="sga-badges-container">
                                    <div v-for="(item, index) in row.item.sga.environment" :key="'environment-' + index"
                                        class="sga-badge sga-environment">
                                        <span class="sga-code">{{ item.codigo }}</span>
                                        <span class="sga-divider">|</span>
                                        <span class="sga-description">{{ item.categoria }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Physical SGA -->
                            <div v-if="(keyProduct === 'sga_physical' || keyProduct === 'risk-inventory') && row.item.sga && row.item.sga.physical && row.item.sga.physical.length"
                                class="sga-category-group">
                                <div v-if="keyProduct === 'risk-inventory'" class="sga-category-label">Físico</div>
                                <div class="sga-badges-container">
                                    <div v-for="(item, index) in row.item.sga.physical" :key="'physical-' + index"
                                        class="sga-badge sga-physical">
                                        <span class="sga-code">{{ item.codigo }}</span>
                                        <span class="sga-divider">|</span>
                                        <span class="sga-description">{{ item.categoria }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>

                    <!-- Disponibilidad -->
                    <template
                        v-else-if="keyProduct === 'inventory_availability' || keyProduct === 'not_use' || keyProduct === 'used'"
                        #cell(categories)="row">
                        <div class="categories-wrapper">
                            <div class="category-badge" :class="getInventoryAvailabilityClass(row.item.in_use)">
                                <i class="fa" :class="row.item.in_use === 'Si' ? 'fa-check' : 'fa-times'"></i>
                                <span class="category-text">
                                    {{ row.item.in_use }}
                                </span>
                            </div>
                        </div>
                    </template>

                    <!-- Sujeto a regulación -->
                    <template v-else-if="keyProduct === 'subjects_regulation'" #cell(categories)="row">
                        <div class="categories-wrapper">
                            <div v-for="(regulation, key) in row.item.regulations" :key="key">
                                <div v-if="regulation" class="category-badge" :class="getRegulationClass(key)">
                                    <span class="category-text">
                                        {{ getRegulationLabel(key) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </template>

                    <!-- Caracterización -->
                    <template
                        v-else-if="keyProduct === 'status_inventory' || keyProduct === 'caracterized' || keyProduct === 'not_caracterized_with_cumply' || keyProduct === 'not_caracterized_not_cumply' || keyProduct === 'not_document'"
                        #cell(categories)="row">
                        <div class="categories-wrapper">
                            <div v-for="(status, key) in row.item.status" :key="key">
                                <div v-if="status" class="category-badge" :class="getStatusInventoryClass(key)">
                                    <span class="category-text">
                                        {{ getStatusInventoryLabel(key) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </template>

                    <!-- Legislaction aplicable -->
                    <!-- cumply,not_cumply,not_document_legislation,cumply_review -->
                    <template
                        v-else-if="keyProduct === 'cumply' || keyProduct === 'not_cumply' || keyProduct === 'not_document_legislation' || keyProduct === 'cumply_review'"
                        #cell(categories)="row">
                        <div class="categories-wrapper">
                            <div v-for="(status, key) in row.item.status" :key="key">
                                <div v-if="status && isLegislationKeyVisible(key)" class="category-badge" :class="getLegislationApplicableClass(key)">
                                    <span class="category-text">
                                        {{ getLegislationApplicableLabel(key) }}
                                    </span>
                                </div>
                            </div>
                        </div>

                    </template>


                    <!-- Ubicaciones -->
                    <template #cell(locations)="row">

                        <b-button v-if="row.item.locations.length" variant="outline-primary" size="sm"
                            @click="row.toggleDetails" class="location-btn">
                            <i class="fa" :class="row.detailsShowing ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                            {{ row.detailsShowing ? 'Ocultar' : 'Ver' }}
                        </b-button>
                        <span v-else class="text-muted">
                            <i class="fa fa-map-marker-slash"></i> Sin ubicaciones
                        </span>
                    </template>

                    <!-- Detalles de ubicaciones -->
                    <template #row-details="row">
                        <div class="location-details">
                            <div v-for="(location, index) in row.item.locations" :key="index" class="location-item">
                                <i class="fa fa-map-marker-alt location-icon"></i>
                                <div class="location-path">
                                    {{ formatLocationPath(location) }}
                                </div>
                            </div>
                        </div>
                    </template>

                    <!-- Acciones -->
                    <template #cell(actions)="row">
                        <div class="actions-wrapper">
                            <b-button variant="outline-info" size="sm" @click="viewProductDetails(row.item)"
                                class="action-btn" v-b-tooltip.hover title="Ver Detalles">
                                <i class="fa fa-eye"></i>
                            </b-button>
                            <b-button variant="outline-warning" size="sm" @click="createTicket(row.item)"
                                class="action-btn" v-b-tooltip.hover title="Crear Ticket" v-if="validarPermisoComponente('crear-ticket-desde-dashboard')">
                                <i class="fa fa-envelope"></i>
                            </b-button>
                        </div>
                    </template>
                </b-table>

                <!-- Estado vacío -->
                <div v-if="filteredProducts.length === 0" class="empty-state">
                    <i class="fa fa-box-open empty-icon"></i>
                    <p class="empty-text">No hay productos disponibles para mostrar.</p>
                </div>
            </div>

            <!-- Paginación -->
            <template #modal-footer>
                <div class="w-100 d-flex justify-content-between align-items-center">
                    <div class="per-page-selector d-flex align-items-center gap-2">
                        <span class="text-nowrap">Mostrar:</span>
                        <b-form-select v-model="pageSize" :options="pageSizeOptions" size="sm"
                            class="w-auto"></b-form-select>
                    </div>
                    <div class="pagination-wrapper p-3">
                        <div class="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
                            <div class="pagination-info">
                                <span class="text-muted">
                                    Mostrando {{ (currentPage - 1) * pageSize + 1 }} -
                                    {{ Math.min(currentPage * pageSize, total) }}
                                    de {{ total }} registros
                                </span>
                            </div>

                            <div class="d-flex align-items-center gap-4">
                            <b-pagination v-model="currentPage" :total-rows="total" :per-page="pageSize" align="center"
                                class="mb-0 custom-pagination" pills></b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </b-modal>
        <b-modal :id="ticketModalId" title="Formulario de tickets" size="lg" @hide="limpiarFormulario" hide-footer>
            <Tickets v-if="selectedTicket !== null" :admin="true" :hideModal="limpiarFormulario"
                :companyId="dashboardCompanyId"></Tickets>
            <div v-else class="text-center p-4">
                <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Cargando...</span>
                </div>
                <p class="mt-2">Inicializando formulario...</p>
            </div>
        </b-modal>
    </div>
</template>
    
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import Tickets from '../../tickets/Tickets.vue';
import { validarPermisoComponente } from '../../../plugins/acl';

export default {
    name: 'ProductListModal',
    props: {
        modalId: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        products: {
            type: Array,
            default: () => []
        },
        keyProduct: {
            type: String,
            default: () => null
        },
        showReviewSection: {
            type: Boolean,
            default: true
        },
    },
    components: {
        Tickets
    },
    async created() {
        // Inicializar estado de tickets si es necesario
        try {
            this.resetSelectedTicket();
            this.resetFiltro();
        } catch (error) {
            console.warn('Error al inicializar estado de tickets:', error);
        }
    },
    data() {
        return {
            currentPage: 1,
            pageSize: 5,
            searchQuery: '',
            selectedState: null,
            selectedVolumeUnit: null,
            selectedGroup: null,
            selectedNeurotoxicLevel: null,
            selectedSensitizingType: null,
            selectedToxicityType: null,
            selectedTargetOrgansType: null,
            selectedSgaType: null,
            selectedSgaCode: null,
            selectedAvailability: null,
            selectedInventoryStatus: null,
            selectedComplianceStatus: null,
            selectedExposureType: null,
            selectedToxicityCategory: null,
            pageSizeOptions: [
                { value: 5, text: '5 por página' },
                { value: 10, text: '10 por página' },
                { value: 20, text: '20 por página' },
                { value: 30, text: '30 por página' },
                { value: 100, text: '100 por página' }
            ],
            carcinogenicityGroups: {
                group_1: { name: 'Grupo 1 - Carcinógeno para seres humanos', color: '#068190' },
                group_2A: { name: 'Grupo 2A - Probablemente carcinógeno', color: '#04373D' },
                group_2B: { name: 'Grupo 2B - Posiblemente carcinógeno', color: '#117ACB' },
                reported_by_sds: { name: 'Reportado FDS', color: '#0FBEF9' }
            },
            neurotoxicLevels: {
                level_1: { name: 'Nivel 1', color: '#068190' },
                level_2: { name: 'Nivel 2', color: '#04373D' },
                level_3: { name: 'Nivel 3', color: '#674485' },
                level_4: { name: 'Nivel 4', color: '#117ACB' },
                level_for_sga: { name: 'Otros', color: '#B45DFF' }
            },
            toxicityAgudeToxicityCategories: {
                toxicity_agude_ingestion: { name: 'Ingestión', color: '#04373D' },
                toxicity_dermal: { name: 'Dérmica', color: '#117ACB' },
                toxicity_inhalation: { name: 'Inhalación', color: '#0FBEF9' }
            },
            targetOrgansCategories: {
                target_organs_exposition_repetitive: { name: 'Exposición repetida', color: '#117ACB' },
                target_organs_exposition_unique: { name: 'Exposición única', color: '#0FBEF9' }
            },
            baseFields: [
                {
                    key: 'name',
                    label: 'Producto',
                    sortable: true,
                    thClass: 'th-product',
                    tdClass: 'td-product'
                },
                {
                    key: 'state',
                    label: 'Estado',
                    thClass: 'text-center th-state',
                    tdClass: 'text-center td-state'
                },
                {
                    key: 'locations',
                    label: 'Ubicaciones',
                    thClass: 'text-center th-locations',
                    tdClass: 'text-center td-locations'
                }
            ],
            validarPermisoComponente: validarPermisoComponente,
        }
    },
    computed: {
        dynamicFields() {
            if (this.keyProduct === 'tank') {
                return [
                    {
                        key: 'name',
                        label: 'Producto',
                        sortable: true,
                        thClass: 'th-product',
                        tdClass: 'td-product'
                    },
                    {
                        key: 'state',
                        label: 'Estado',
                        thClass: 'text-center th-state',
                        tdClass: 'text-center td-state'
                    },
                    {
                        key: 'tank_number',
                        label: 'Número del Tanque',
                        thClass: 'text-center',
                        tdClass: 'text-center font-weight-bold'
                    },
                    {
                        key: 'quantity',
                        label: 'Cantidad',
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                    {
                        key: 'volume_unit',
                        label: 'Unidad',
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    },
                    {
                        key: 'locations',
                        label: 'Ubicaciones',
                        thClass: 'text-center th-locations',
                        tdClass: 'text-center td-locations'
                    }
                ];
            }

            const fields = [...this.baseFields];
            if (this.shouldShowCategories) {
                fields.splice(2, 0, {
                    key: 'categories',
                    label: this.getCategoryLabel(),
                    thClass: 'text-center th-categories',
                    tdClass: 'text-center td-categories'
                });
            }

            // Agregar columna de acciones al final
            fields.push({
                key: 'actions',
                label: 'Acciones',
                thClass: 'text-center th-actions',
                tdClass: 'text-center td-actions'
            });

            return fields;
        },

        shouldShowCategories() {
            const categoryKeys = [
                'acute_toxicity_mortal', 'carcinogenicity', 'neurotoxic',
                'corrosive', 'sensitizing', 'toxicity_agude_toxicity',
                'target_organs', 'sga_health', 'sga_environment',
                'sga_physical', 'risk-inventory', 'inventory_availability',
                'not_use', 'used', 'subjects_regulation', 'caracterized',
                'not_caracterized_with_cumply', 'not_caracterized_not_cumply',
                'not_document', 'status_inventory', 'cumply', 'not_cumply',
                'not_document_legislation', 'cumply_review'
            ];
            return categoryKeys.includes(this.keyProduct);
        },

        stateOptions() {
            const states = ['Liquido', 'Solido', 'Gaseoso'];
            return [
                { value: null, text: 'Todos los estados' },
                ...states.map(state => ({ value: state, text: state }))
            ];
        },
        volumeUnitOptions() {
            if (this.keyProduct !== 'tank') return [];

            const units = [...new Set(this.products.map(item => item.volume_unit))].filter(Boolean);
            return [
                { value: null, text: 'Todas las unidades' },
                ...units.map(unit => ({ value: unit, text: unit }))
            ];
        },
        groupOptions() {
            if (this.keyProduct !== 'carcinogenicity') return [];

            return [
                { value: null, text: 'Todos los grupos' },
                { value: 'group_1', text: 'Grupo 1 - Carcinógeno para seres humanos' },
                { value: 'group_2A', text: 'Grupo 2A - Probablemente carcinógeno' },
                { value: 'group_2B', text: 'Grupo 2B - Posiblemente carcinógeno' },
                { value: 'reported_by_sds', text: 'Reportado FDS' }
            ];
        },
        neurotoxicLevelOptions() {
            if (this.keyProduct !== 'neurotoxic') return [];

            return [
                { value: null, text: 'Todos los niveles' },
                { value: 'level_1', text: 'Nivel 1' },
                { value: 'level_2', text: 'Nivel 2' },
                { value: 'level_3', text: 'Nivel 3' },
                { value: 'level_4', text: 'Nivel 4' },
                { value: 'level_for_sga', text: 'Otros' }
            ];
        },
        sensitizingTypeOptions() {
            return this.keyProduct === 'sensitizing' ? [
                { value: null, text: 'Todos los tipos' },
                { value: 'dermal', text: 'Cutánea' },
                { value: 'respiratory', text: 'Respiratoria' },
                { value: 'both', text: 'Ambos' }
            ] : [];
        },
        toxicityTypeOptions() {
            return this.keyProduct === 'toxicity_agude_toxicity' ? [
                { value: null, text: 'Todos los tipos' },
                { value: 'ingestion', text: 'Ingestión' },
                { value: 'inhalation', text: 'Inhalación' },
                { value: 'dermal', text: 'Dérmica' },
                { value: 'all', text: 'Todas las vías de ingreso' }
            ] : [];
        },
        targetOrgansTypeOptions() {
            return this.keyProduct === 'target_organs' ? [
                { value: null, text: 'Todos los tipos' },
                { value: 'repetitive', text: 'Exposición Repetida' },
                { value: 'unique', text: 'Exposición Única' },
                { value: 'both', text: 'Ambos' }
            ] : [];
        },
        sgaTypeOptions() {
            if (this.keyProduct !== 'risk-inventory') return [];

            return [
                { value: null, text: 'Todos los tipos' },
                { value: 'health', text: 'Salud' },
                { value: 'environment', text: 'Ambiente' },
                { value: 'physical', text: 'Físico' }
            ];
        },
        sgaCodeOptions() {
            if (!['risk-inventory', 'sga_health', 'sga_environment', 'sga_physical'].includes(this.keyProduct)) return [];

            const codes = new Set();
            let sgaType;

            if (this.keyProduct === 'risk-inventory') {
                if (!this.selectedSgaType) return [];
                sgaType = this.selectedSgaType;
            } else {
                sgaType = this.keyProduct.replace('sga_', '');
            }

            this.products.forEach(product => {
                if (product.sga && product.sga[sgaType]) {
                    product.sga[sgaType].forEach(item => {
                        if (item && item.codigo) {
                            codes.add(item.codigo);
                        }
                    });
                }
            });

            const sortedCodes = Array.from(codes).sort();
            return [
                { value: null, text: 'Todos los códigos' },
                ...sortedCodes.map(code => ({ value: code, text: code }))
            ];
        },
        availabilityOptions() {
            if (!['inventory_availability', 'not_use', 'used'].includes(this.keyProduct)) return [];

            return [
                { value: null, text: 'Todas las disponibilidades' },
                { value: 'Si', text: 'Si' },
                { value: 'No', text: 'No' }
            ];
        },
        inventoryStatusOptions() {
            if (!['status_inventory', 'caracterized', 'not_caracterized_with_cumply', 'not_caracterized_not_cumply', 'not_document'].includes(this.keyProduct)) return [];

            return [
                { value: null, text: 'Todos los estados' },
                { value: 'caracterized', text: 'Caracterizado' },
                { value: 'not_caracterized_with_cumply', text: 'Sin caracterización con cumplimiento' },
                { value: 'not_caracterized_not_cumply', text: 'Sin caracterización sin cumplimiento' },
                { value: 'not_document', text: 'Sin documento' }
            ];
        },
        complianceStatusOptions() {
            if (this.keyProduct !== 'cumply_review') return [];

            return [
                { value: null, text: 'Todos los productos' },
                { value: 'attachment_not_revision', text: 'Por revisar' },
                { value: 'attachment_with_revision', text: 'Revisado' }
            ];
        },
        exposureTypeOptions() {
            if (this.keyProduct !== 'acute_toxicity_mortal') return [];

            return [
                { value: null, text: 'Todos los tipos' },
                { value: 'oral', text: 'Ingestión' },
                { value: 'dermal', text: 'Dérmica' },
                { value: 'inhalation', text: 'Inhalación' }
            ];
        },
        toxicityCategoryOptions() {
            if (this.keyProduct !== 'acute_toxicity_mortal') return [];

            return [
                { value: null, text: 'Todas las categorías' },
                { value: 'category_1', text: 'Categoría 1' },
                { value: 'category_2', text: 'Categoría 2' }
            ];
        },
        filteredProducts() {
            let filtered = this.normalizedProducts;

            // Aplicar filtro de búsqueda
            if (this.searchQuery) {
                const query = this.searchQuery.toLowerCase();
                filtered = filtered.filter(product => {
                    let name = '';
                    let manufacturer = '';
                    let tankNumber = '';

                    if (this.keyProduct === 'tank') {
                        name = (product.product && product.product.name) ? product.product.name.toLowerCase() : '';
                        manufacturer = (product.product && product.product.manufacturer) ? product.product.manufacturer.toLowerCase() : '';
                        tankNumber = product.tank_number ? product.tank_number.toLowerCase() : '';
                    } else {
                        name = product.name ? product.name.toLowerCase() : '';
                        manufacturer = product.manufacturer ? product.manufacturer.toLowerCase() : '';
                    }

                    return (name && name.includes(query)) ||
                        (manufacturer && manufacturer.includes(query)) ||
                        (tankNumber && tankNumber.includes(query));
                });
            }

            // Aplicar filtro de estado
            if (this.selectedState) {
                filtered = filtered.filter(product => {
                    const state = this.keyProduct === 'tank'
                        ? (product.product && product.product.status)
                        : product.state;
                    return state === this.selectedState;
                });
            }

            // Aplicar filtro de unidad de volumen (solo para tanks)
            if (this.keyProduct === 'tank' && this.selectedVolumeUnit) {
                filtered = filtered.filter(product => product.volume_unit === this.selectedVolumeUnit);
            }

            // Aplicar filtro de grupo (solo para carcinogenicidad)
            if (this.keyProduct === 'carcinogenicity' && this.selectedGroup) {
                filtered = filtered.filter(product => {
                    return product.groups && product.groups[this.selectedGroup];
                });
            }

            // Aplicar filtro de nivel neurotóxico (solo para neurotoxic)
            if (this.keyProduct === 'neurotoxic' && this.selectedNeurotoxicLevel) {
                filtered = filtered.filter(product => {
                    return product.neurotoxic_level === this.selectedNeurotoxicLevel;
                });
            }

            // Aplicar filtro de tipo de sensibilización (solo para sensitizing)
            if (this.keyProduct === 'sensitizing' && this.selectedSensitizingType) {
                filtered = filtered.filter(product => {
                    if (!product.sensitizing) return false;

                    const hasDermal = product.sensitizing.dermal === true;
                    const hasRespiratory = product.sensitizing.respiratory === true;

                    switch (this.selectedSensitizingType) {
                        case 'dermal':
                            return hasDermal; // Solo cutáneo
                        case 'respiratory':
                            return hasRespiratory; // Solo respiratorio
                        case 'both':
                            return hasDermal && hasRespiratory; // Ambos tipos
                        default:
                            return true;
                    }
                });
            }

            // Aplicar filtro de tipo de toxicidad aguda
            if (this.keyProduct === 'toxicity_agude_toxicity' && this.selectedToxicityType) {
                filtered = filtered.filter(product => {
                    if (!product.toxicities) return false;

                    const hasIngestion = product.toxicities.product_toxicity_agude_ingestion === true;
                    const hasInhalation = product.toxicities.product_toxicity_inhalation === true;
                    const hasDermal = product.toxicities.product_toxicity_dermal === true;

                    switch (this.selectedToxicityType) {
                        case 'ingestion':
                            return hasIngestion;
                        case 'inhalation':
                            return hasInhalation;
                        case 'dermal':
                            return hasDermal;
                        case 'all':
                            return hasIngestion && hasInhalation && hasDermal;
                        default:
                            return true;
                    }
                });
            }

            // Aplicar filtro de tipo de exposición a órganos diana
            if (this.keyProduct === 'target_organs' && this.selectedTargetOrgansType) {
                filtered = filtered.filter(product => {
                    if (!product.target_organs) return false;

                    const hasRepetitive = product.target_organs.product_target_organs_exposition_repetitive === true;
                    const hasUnique = product.target_organs.product_target_organs_exposition_unique === true;

                    switch (this.selectedTargetOrgansType) {
                        case 'repetitive':
                            return hasRepetitive;
                        case 'unique':
                            return hasUnique;
                        case 'both':
                            return hasRepetitive && hasUnique;
                        default:
                            return true;
                    }
                });
            }

            // Apply SGA type filter
            if (this.keyProduct === 'risk-inventory' && this.selectedSgaType) {
                filtered = filtered.filter(product => {
                    return product.sga &&
                        product.sga[this.selectedSgaType] &&
                        product.sga[this.selectedSgaType].length > 0;
                });
            }

            // Apply SGA code filter
            if (['risk-inventory', 'sga_health', 'sga_environment', 'sga_physical'].includes(this.keyProduct) && this.selectedSgaCode) {
                const sgaType = this.keyProduct === 'risk-inventory' ? this.selectedSgaType : this.keyProduct.replace('sga_', '');
                filtered = filtered.filter(product => {
                    return product.sga &&
                        product.sga[sgaType] &&
                        product.sga[sgaType].some(item => item.codigo === this.selectedSgaCode);
                });
            }

            // Apply availability filter
            if (['inventory_availability', 'not_use', 'used'].includes(this.keyProduct) && this.selectedAvailability) {
                filtered = filtered.filter(product => product.in_use === this.selectedAvailability);
            }

            // Apply inventory status filter
            if (['status_inventory', 'caracterized', 'not_caracterized_with_cumply', 'not_caracterized_not_cumply', 'not_document'].includes(this.keyProduct) && this.selectedInventoryStatus) {
                filtered = filtered.filter(product => product.status && product.status[this.selectedInventoryStatus]);
            }

            // Apply compliance status filter
            if (this.keyProduct === 'cumply_review' && this.selectedComplianceStatus) {
                filtered = filtered.filter(product => product.status && product.status[this.selectedComplianceStatus]);
            }

            // Apply acute toxicity mortal filters
            if (this.keyProduct === 'acute_toxicity_mortal') {
                if (this.selectedExposureType) {
                    filtered = filtered.filter(product => {
                        if (!product.categories || !product.categories[this.selectedExposureType]) return false;

                        if (this.selectedToxicityCategory) {
                            return product.categories[this.selectedExposureType][this.selectedToxicityCategory];
                        }

                        return Object.values(product.categories[this.selectedExposureType]).some(value => value);
                    });
                } else if (this.selectedToxicityCategory) {
                    filtered = filtered.filter(product => {
                        if (!product.categories) return false;

                        return Object.values(product.categories).some(exposureType =>
                            exposureType[this.selectedToxicityCategory]
                        );
                    });
                }
            }

            return filtered;
        },

        normalizedProducts() {
            if (this.keyProduct === 'tank') {
                return this.products.map(item => ({
                    ...item,
                    name: item.product && item.product.name || '',
                    manufacturer: item.product && item.product.manufacturer || '',
                    state: item.product && item.product.status || '',
                    locations: [item.location],
                    tank_number: item.tank_number || '',
                    quantity: this.formatNumber(item.quantity || 0),
                    volume_unit: item.volume_unit || ''
                }));
            }
            return this.products;
        },

        total() {
            return this.filteredProducts.length;
        },
        ...mapState("tickets", [
            "selectedTicket"
        ]),
        ...mapState("tareas", ["ubicaciones"]),
        ...mapState("dashboard", ["dashboardFilters"]),

        /**
         * Empresa seleccionada en el filtro del dashboard, sobre la cual se
         * consultan los campos personalizados del ticket.
         *
         * @returns {number|null}
         */
        dashboardCompanyId() {
            return (this.dashboardFilters && this.dashboardFilters.company_id) || null;
        },

        /**
         * Identificador único del modal de tickets.
         *
         * El dashboard renderiza varias instancias de este componente (la pantalla
         * y CenterBody), por lo que un id fijo abriría todos los modales a la vez y
         * montaría varios formularios de tickets compitiendo por el mismo estado.
         *
         * @returns {string}
         */
        ticketModalId() {
            return `modal-ticket-${this.modalId}`;
        },
    },
    methods: {
        /**
         * Determina si una clave de badge de legislación debe mostrarse
         * según la configuración de revisión normativa del país.
         *
         * @param {string} key - Clave del estado de revisión
         * @returns {boolean}
         */
        isLegislationKeyVisible(key) {
            if (this.showReviewSection) return true;
            return key !== 'attachment_with_revision' && key !== 'attachment_not_revision';
        },
        formatNumber(number) {
            return new Intl.NumberFormat('es-CO').format(number);
        },
        getCategoryLabel() {
            const labels = {
                'acute_toxicity_mortal': 'Categorías',
                'carcinogenicity': 'Grupos',
                'neurotoxic': 'Nivel Neurotóxico',
                'corrosive': 'Corrosividad',
                'sensitizing': 'Sensibilizantes',
                'toxicity_agude_toxicity': 'Toxicidad',
                'target_organs': 'Exposición',
                'sga_health': 'SGA',
                'sga_environment': 'SGA',
                'sga_physical': 'SGA',
                'risk-inventory': 'Peligrosidad del Inventario',
                'inventory_availability': 'Disponible en inventario',
                'not_use': 'Disponible en inventario',
                'used': 'Disponible en inventario',
                'subjects_regulation': 'Sujetos a regulación',
                'status_inventory': 'Estatus de inventario',
                'caracterized': 'Estatus de inventario',
                'not_caracterized_with_cumply': 'Estatus de inventario',
                'not_caracterized_not_cumply': 'Estatus de inventario',
                'not_document': 'Estatus de inventario',
                'cumply': 'Legislación Aplicable',
                'not_cumply': 'Legislación Aplicable',
                'not_document_legislation': 'Legislación Aplicable',
                'cumply_review': 'Legislación Aplicable'
            };
            return labels[this.keyProduct] || 'Categorías';
        },
        getStateClass(state) {
            const stateMap = {
                'Liquido': 'state-liquid',
                'Solido': 'state-solid',
                'Gaseoso': 'state-gas'
            };
            return stateMap[state] || '';
        },
        getStateIcon(state) {
            const iconMap = {
                'Liquido': 'fa fa-tint',
                'Solido': 'fa fa-cube',
                'Gaseoso': 'fa fa-wind'
            };
            return iconMap[state] || 'fa fa-question';
        },
        getCategoryClass(category) {
            return category === 'category_1' ? 'category-primary' : 'category-success';
        },
        getCategoryIcon(type) {
            const iconMap = {
                'oral': 'fa-medkit',
                'dermal': 'fa-hand-paper-o',
                'inhalation': 'fa-cloud'
            };
            return iconMap[type] || 'fa-exclamation-triangle';
        },
        formatLocationPath(location) {
            const path = [];
            let current = location;
            while (current) {
                path.unshift(current.description);
                current = current.parent_location;
            }
            return path.join(' > ');
        },
        getCarcinogenicityClass(group) {
            return `carcinogenicity-${group.toLowerCase()}`;
        },
        getCarcinogenicityLabel(group) {
            return this.carcinogenicityGroups[group] && this.carcinogenicityGroups[group].name || group;
        },
        getNeurotoxicClass(level) {
            return `neurotoxic-${level.toLowerCase()}`;
        },
        getNeurotoxicLabel(level) {
            return this.neurotoxicLevels[level] && this.neurotoxicLevels[level].name || level;
        },
        getSgaTypeClass(type) {
            const classMap = {
                'sga_health': 'sga-health',
                'sga_environment': 'sga-environment',
                'sga_physical': 'sga-physical',
                'risk-inventory': ''
            };
            return classMap[type] || '';
        },
        getInventoryAvailabilityClass(inUse) {
            return inUse === 'Si' ? 'category-primary' : 'category-danger';
        },
        getRegulationLabel(key) {
            const labels = {
                'ppam': 'PPAM',
                'un_danger': 'Mercancía peligrosa',
                'carcinogenic': 'Carcinógeno',
                'sga_death': 'Mortal'
            };
            return labels[key] || key;
        },
        getRegulationClass(key) {
            const classMap = {
                'ppam': 'ppam',
                'un_danger': 'un-danger',
                'carcinogenic': 'carcinogenic',
                'sga_death': 'sga-death'
            };
            return classMap[key] || '';
        },
        getStatusInventoryClass(key) {
            const classMap = {
                'caracterized': 'caracterized',
                'not_caracterized_with_cumply': 'not_caracterized_with_cumply',
                'not_caracterized_not_cumply': 'not_caracterized_not_cumply',
                'not_document': 'not_document'
            };
            return classMap[key] || '';
        },
        getStatusInventoryLabel(key) {
            const labels = {
                'caracterized': 'Caracterizado',
                'not_caracterized_with_cumply': 'Sin caracterización con cumplimiento',
                'not_caracterized_not_cumply': 'Sin caracterización sin cumplimiento',
                'not_document': 'Sin documento'
            };
            return labels[key] || key;
        },
        getLegislationApplicableClass(key) {
            const classMap = {
                'cumply': 'cumply',
                'not_cumply': 'not_cumply',
                'not_document_legislation': 'not_document_legislation',
                'attachment_not_revision': 'attachment_with_revision',
                'attachment_with_revision': 'attachment_not_revision'
            };
            return classMap[key] || '';
        },
        getLegislationApplicableLabel(key) {
            const labels = {
                'cumply': 'Cumple',
                'not_cumply': 'No cumple',
                'not_document_legislation': 'Sin documento',
                'attachment_not_revision': 'Por revisar',
                'attachment_with_revision': 'Revisado'
            };
            return labels[key] || key;
        },
        viewProductDetails(product) {
            window.open(`/#/productos/${product.id}`, '_blank');
        },
        async createTicket(product) {
            try {
                this.resetSelectedTicket();
                this.setArbolEmpresa({ data: this.ubicaciones || [] });
                this.setSelectedTicketUsingProduct(product);
                this.getProducerByName(product.manufacturer);
                // Se cargan antes de abrir el modal para que el formulario muestre
                // los campos personalizados de la empresa seleccionada en el dashboard.
                await this.getTicketCustomFields(this.dashboardCompanyId);
                this.$bvModal.show(this.ticketModalId);
            } catch (error) {
                console.error('Error al crear ticket:', error);
            }
        },
         limpiarFormulario() {
            try {
                this.resetSelectedTicket();
                this.resetFiltro();
                this.$bvModal.hide(this.ticketModalId);
            } catch (error) {
                console.error('Error al limpiar formulario:', error);
            }
        },
        ...mapMutations('tickets', [
            'setRol',
            'resetSelectedTicket',
            'resetFiltro',
            'setSelectedTicketUsingProduct',
            "setLocationsToTicket"
        ]),
        ...mapMutations("location", ["setArbolEmpresa"]),
        ...mapActions("tickets", ["getTicketCustomFields"]),
        ...mapActions("accidents_high", [
            "getProducerByName",
        ]),
    },
    watch: {
        keyProduct(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.currentPage = 1;
                this.selectedState = null;
                this.selectedVolumeUnit = null;
                this.selectedGroup = null;
                this.selectedNeurotoxicLevel = null;
                this.selectedSensitizingType = null;
                this.selectedToxicityType = null;
                this.selectedTargetOrgansType = null;
                this.selectedSgaType = null;
                this.selectedSgaCode = null;
                this.selectedAvailability = null;
                this.selectedInventoryStatus = null;
                this.selectedComplianceStatus = null;
                this.selectedExposureType = null;
                this.selectedToxicityCategory = null;
            }
        },
        selectedExposureType(newVal) {
            if (newVal === null) {
                this.selectedToxicityCategory = null;
            }
        },
        selectedSgaType() {
            this.selectedSgaCode = null;
        }
    }
}
</script>

<style scoped src="./styles/ProductListModal.css"></style>